import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';

/** نگاشت آیکون‌ها به FontAwesomeهای ثبت‌شده در initFA پنل */
const ICON_MAP: Record<string, IconProp> = {
  'arrow-clockwise': 'sync-alt',
  'box-arrow-up-right': 'external-link-alt',
  'calendar-event': 'calendar-alt',
  'card-text': 'file-alt',
  'check-circle-fill': 'check-circle',
  'chevron-down': 'chevron-down',
  'chevron-left': 'chevron-left',
  'chevron-up': 'chevron-up',
  circle: 'circle',
  'clock-history': 'history',
  collection: 'layer-group',
  copy: 'copy',
  'diagram-3': 'project-diagram',
  'exclamation-triangle': 'exclamation-triangle',
  'exclamation-circle': 'exclamation-circle',
  globe2: 'globe',
  google: ['fab', 'google'],
  'info-circle': 'info-circle',
  'journal-text': 'book',
  'link-45deg': 'link',
  'question-circle': 'question-circle',
  search: 'search',
  table: 'table',
  'pie-chart': 'chart-pie',
  'bar-chart': 'chart-line',
  'file-earmark-text': 'file-alt',
  'list-ul': 'list-ul',
  'arrow-repeat': 'sync-alt',
  speedometer2: 'tachometer-alt',
  'arrow-left-right': 'exchange-alt',
  robot: 'robot',
};

export function IndexerIcon({
  name,
  className,
  fixedWidth,
}: {
  name: string;
  className?: string;
  fixedWidth?: boolean;
}) {
  const normalized = name.replace(/^bi-/, '').replace(/^bi\s+bi-/, '');
  const icon = ICON_MAP[normalized] ?? 'circle';
  return (
    <FontAwesomeIcon
      icon={icon}
      className={className}
      fixedWidth={fixedWidth}
      aria-hidden
    />
  );
}
